/* eslint-disable quote-props */
const ptMessages = {
  'title': 'Catálogo Oficial da CARDS PAYMENT & ID 2017',
  'shortTitle': 'Catálogo CARDS',
  // Navigation
  'generalProgramming': 'Programação Geral',
  'sponsors': 'Patrocinadores',
  'personalities': 'Personalidades',
  'roundTables': 'Painéis',
  'agenda': 'Agenda',
  'keynotes': 'Palestrantes',
  'mediaPartners': 'Media Partners',
  'floorplan': 'Floorplan',
  'exhibitors': 'Expositores',
  'testimonials': 'Depoimentos',
  'organization': 'Organização',
  'futurecomWebsite': 'Site do CARDS',
  'seeMore': 'Veja mais',
  'back': 'Voltar',
  // Titles
  'coordinator': '{gender, select, female {Coordenadora} other {Coordenador}}',
  'invitedPanelists': 'Painelistas convidados',
  'participationAtTheCongress': 'Participação no Congresso:',
  'description': 'Descrição:',
  'scope': 'Abrangência:',
  'language': 'Idioma de Publicação:',
  'themes': 'Temas de destaque:',
  'locale': 'Localização:',
  'mainExecutive': 'Principal Executivo: ',
  'marketingExecutive': 'Responsável de Marketing: ',
  'others': 'Outros:',
  'roundTableDetailsRoom': '{icon} Auditório {room}',
  // Paragraphs
  'agendaText': 'Veja a Agenda completa da CARDS 2017 em:',
  'floorplanText': 'Veja a Planta Baixa completa da CARDS 2017 em:',
  'organizationText':
    `
      CARDS é parte da Global Exhibitions Division da Informa PLC.
    `,
  // Date and time
  'roundTableDateTime': '{icon} {date, date, short}, das {starting, time, short} às {ending, time, short}',
  'roundTableDetailsDateTime': '{icon} {date, date}, das {starting, time, short} às {ending, time, short}',
  'roundTableRoom': '{icon} AUDITÓRIO {room}',
  'time': 'das {starting, time, short} às {ending, time, short}',
  // Other
  'booth': '+',
  'search': 'Buscar...',
  // No data
  'noData': 'Nenhum dado encontrado.',
};
/* eslint-enable */

export default ptMessages;



/** WEBPACK FOOTER **
 ** ./src/intl/ptMessages.js
 **/